/**
 * Shared prompt theme utilities for @inquirer/prompts
 * Adds "Ctrl+C quit" to help line for all interactive prompts
 */

/**
 * Custom keysHelpTip that appends "Ctrl+C quit" to the help line
 */
export const keysHelpTipWithQuit = (keys: [key: string, action: string][]): string => {
    const keyStrings = keys.map(([key, action]) => `${key} ${action}`);
    keyStrings.push('Ctrl+C quit');
    return keyStrings.join(' • ');
};

/**
 * Theme configuration for checkbox prompts with Ctrl+C quit hint
 */
export const checkboxTheme = {
    style: {
        keysHelpTip: keysHelpTipWithQuit,
    },
};

/**
 * Theme configuration for select prompts with Ctrl+C quit hint
 */
export const selectTheme = {
    style: {
        keysHelpTip: keysHelpTipWithQuit,
    },
};
